<template>
  <div
    data-component="agent-picker-input"
    :class="{ 'is-disabled': isDisabled }"
  >
    <div class="label">
      {{ label || $t('hitl.modules.agent-picker.input-label') }}
    </div>

    <div
      class="input"
      data-input
      :class="{ 'is-disabled': isDisabled }"
      @click="onInputClick"
    >
      <agent-avatar
        v-if="!!agent"
        :avatar="avatar"
        :person="agent"
      />

      <span
        v-if="!!agent"
        class="username"
      >
        {{ username }}
      </span>

      <span
        v-if="!agent"
        class="placeholder"
      >
        {{ placeholderText }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';

import { AgentAvatar } from '@onereach/hitl-base-avatars';
import { getAgentName } from '@/common';
import { AGENT_PROP, AVATAR_PROP } from '../constants';

export default defineComponent({
  name: 'AgentPickerInput',
  components: {
    AgentAvatar,
  },
  props: {
    avatar: AVATAR_PROP,
    agent: AGENT_PROP,
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    isDisabled: Boolean,
  },
  emits: ['click'],
  computed: {
    username() {
      return this.agent ? getAgentName(this.agent, this.$t.bind(this)) : '';
    },
    placeholderText() {
      return this.placeholder || this.$t('hitl.modules.agent-picker.input-placeholder');
    },
  },
  methods: {
    onInputClick() {
      if (!this.isDisabled) {
        this.$emit('click');
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

[data-component='agent-picker-input'] {
  --agent-picker-text-color: var(--or-c-outline);

  display: flex;
  flex-direction: column;
  gap: var(--s-2);

  &.is-disabled {
    --agent-picker-text-color: var(--or-c-disabled);

    .username {
      color: var(--or-c-disabled);
    }
  }

  .label,
  .placeholder {
    color: var(--agent-picker-text-color);
  }

  .username {
    @include text-overflow;
  }

  .label {
    font-size: var(--fs-0);
    line-height: 1.5;
  }

  .input {
    display: flex;
    align-items: center;
    gap: var(--s-3);
    min-height: 2.25rem;
    padding: var(--s-2) 0.75rem;
    color: var(--or-c-on-background);
    border: 1px solid var(--agent-picker-text-color);
    border-radius: var(--s-2);
    cursor: pointer;

    &.is-disabled {
      cursor: not-allowed;
    }

    &:hover:not(.is-disabled) {
      background: var(--or-c-primary-opacity-0-08);
    }
  }
}
</style>
